import React, { useEffect, useState, useRef, useContext } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ReactHtmlParser from "react-html-parser";
import DOMPurify from "dompurify";
import { EWContext } from "../../../../context/EWContext";
import { LANGUAGE_TEXT } from "../../../../constants";

export default function EligibilityAccordion(props) {
   const { question, handleExpandedTandc, value, extraValues } = props;
   const [expanded, setExpanded] = useState(question.field.open || false);
   const [reachedBottom, setReachedBottom] = useState(
      extraValues.tandcReaded || false
   );
   const accordionRef = useRef();
   const accountState = useContext(EWContext)[0];

   useEffect(() => {
      if (value) setReachedBottom(true);
      // eslint-disable-next-line
   }, []);

   useEffect(() => {
      handleExpandedTandc(question.id, reachedBottom);
      // eslint-disable-next-line
   }, [reachedBottom]);

   const handleScroll = () => {
      if (accordionRef.current) {
         const { scrollTop, scrollHeight, clientHeight } = accordionRef.current;
         if (scrollTop + clientHeight === scrollHeight) setReachedBottom(true);
      }
   };

   const handleChange = () => {
      setExpanded((prevState) => !prevState);
      if (accordionRef.current) {
         const { scrollTop, scrollHeight, clientHeight } = accordionRef.current;
         if (scrollTop + clientHeight === scrollHeight) setReachedBottom(true);
      }
   };

   return (
      <>
         {question.field.type === "tandc" && (
            <Typography variant="h5" tabIndex="0">
               {accountState?.conditionSpecificBehaviors?.translateText &&
               accountState?.storeInfo?.languageCode
                  ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                       ?.expand_terms_and_condition
                  : "Please expand and read the program Terms and Conditions before confirming your acceptance"}
            </Typography>
         )}
         <Accordion
            square
            expanded={expanded}
            onChange={handleChange}
            onScroll={handleScroll}
            ref={accordionRef}
         >
            <AccordionSummary
               id={question.id}
               tabIndex="0"
               aria-label={`${question.id}-label`}
               aria-controls={`${question.id}-content`}
               expandIcon={<ExpandMoreIcon />}
            >
               <Typography variant="overline">{question.label}</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography
                  variant="h5"
                  tabIndex="0"
                  style={{ minWidth: "100%" }}
               >
                  {ReactHtmlParser(DOMPurify.sanitize(question.content))}
               </Typography>
            </AccordionDetails>
         </Accordion>
      </>
   );
}
